export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSirkaDisku';
export const NAME = 'SirkaDisku';
